// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3RBuT","title":"Images45_title__8xWWC","images":"Images45_images__164nI"};